import {filter, includes} from "lodash";
import {stateMerge} from "@/store/object-merge";

const getDefaultState = () => {
    return {
        items: {},
    }
};

const state = getDefaultState();

const getters = {
    byTargetEventId: state => (id) => {
        return filter(state.items, (o) => {
            return o.targetEventId === id;
        });
    },
    bySourceEventId: state => (id) => {
        return filter(state.items, (o) => {
            return o.sourceEventId === id;
        });
    },
    byTargetEventIds: state => (ids) => {
        return filter(state.items, (o) => {
            return includes(ids, o.targetEventId);
        });
    },
};

const actions = {
    async set({commit}, items) {
        if (items)
            commit("MERGE_STATE", items)
    },
};

const mutations = {
    MERGE_STATE(state, data) {
        stateMerge(state, data, 'items', false, true)
    },
    resetState(state, payload) {
        Object.assign(state, getDefaultState());
        if (payload)
            Object.assign(state, payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
